import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import "@/assets/style/index.less";
// element-ui 按需引入：直接从 lib/路径 import，避开 barrel 文件
import Input from "element-ui/lib/input";
import Carousel from "element-ui/lib/carousel";
import CarouselItem from "element-ui/lib/carousel-item";
import "element-ui/lib/theme-chalk/base.css";
import "element-ui/lib/theme-chalk/input.css";
import "element-ui/lib/theme-chalk/carousel.css";
import "element-ui/lib/theme-chalk/carousel-item.css";

Vue.use(Input);
Vue.use(Carousel);
Vue.use(CarouselItem);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
